import { Tr, Td } from '@chakra-ui/react';
import { Box, usePrefersReducedMotion } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

interface LoadingBoxProps {
  width: string;
  height?: string;
}

interface LoadingRowsProps {
  limit: number;
  columns: Array<{
    width: string;
    height?: string;
  }>;
  rowHeight?: string;
}

export const LoadingRows = ({ limit, columns, rowHeight = '53px' }: LoadingRowsProps) => {
  return (
    <>
      {Array.from({ length: limit }).map((_, index) => (
        <Tr key={`loading-${index}`}>
          {columns.map((column, colIndex) => (
            <Td key={`col-${colIndex}`} height={rowHeight}>
              <LoadingBox width={column.width} height={column.height} />
            </Td>
          ))}
        </Tr>
      ))}
    </>
  );
};

const LoadingBox = ({ width, height = '20px' }: LoadingBoxProps) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const animation = prefersReducedMotion ? undefined : `${shimmer} 3s linear infinite`;

  return (
    <Box
      height={height}
      width={width}
      background="linear-gradient(90deg, #f0f0f0 0px, #e0e0e0 40px, #f0f0f0 80px)"
      backgroundSize="1000px 100%"
      animation={animation}
      borderRadius="sm"
    />
  );
};
